import { useForm } from 'react-hook-form';
import { Input } from '../../../forms/Input';
import { Button } from '../../../Button';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import * as routes from '../../../../constants/Routes';

interface IFormRegisterAction {
  email: string;
  password: string;
  name: string;
  action: string;
  terms: any;
}

interface IFormRegisterDinamic {
  action: string;
  client: string;
  player: string;
}

export function FormRegisterDinamic({
  action,
  player,
  client,
}: IFormRegisterDinamic) {
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm<IFormRegisterAction>();

  function handleForm(data: IFormRegisterAction) {
    navigate(
      `/register?quickRegister=true&email=${data.email}&password=${btoa(
        data.password
      )}&name=${data.name}&action=${action}&player=${player}&client=${client}`
    );
  }

  function handleError(data: any) {
    if (data.terms) {
      toast.info(data.terms.message);
    }
    if (data.name) {
      toast.info(data.name.message);
    }
    if (data.email) {
      toast.info(data.email.message);
    }
    if (data.password) {
      toast.info(data.password.message);
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(handleForm, handleError)}>
        <div className="row">
          <div className="col-12">
            <div className="mb-3">
              <Input
                type="text"
                {...register('name', {
                  required: 'Preencha com seu nome!',
                })}
                placeholder="Nome"
              />
            </div>
          </div>
          <div className="col-12">
            <div className="mb-3">
              <Input
                type="email"
                {...register('email', {
                  required: 'Preencha seu e-mail!',
                })}
                placeholder="E-mail"
              />
            </div>
          </div>
          <div className="col-12">
            <div className="mb-3">
              <Input
                type="password"
                {...register('password', {
                  required: 'Crie uma senha!',
                })}
                placeholder="Senha"
              />
            </div>
          </div>
          <div className="my-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="flexCheckDefaultRegister"
                {...register('terms', {
                  required: 'Aceite os termos!',
                })}
              />
              <label
                className="form-check-label"
                htmlFor="flexCheckDefaultRegister"
              >
                Ao clicar em "Cadastrar", você concorda com as{' '}
                <a
                  className="text-primary-color"
                  target="_blank"
                  href="https://firebasestorage.googleapis.com/v0/b/oqhomapi.appspot.com/o/TermsAndPolitics%2FPoli%CC%81tica%20de%20Privacidade_OQ%20MIDIA%20DIGITAL%20JULHO%202020.docx.pdf?alt=media&token=73c99224-963a-40c8-b385-618bb2cc5122"
                >
                  Politicas de Privacidade
                </a>{' '}
                e{' '}
                <a
                  className="text-primary-color"
                  target="_blank"
                  href={routes.TERMS}
                >
                  Termos de uso
                </a>{' '}
                da plataforma.
              </label>
            </div>
          </div>
          <div className="d-grid">
            <Button color="primary" text="Cadastre-se grátis" />
          </div>
        </div>
      </form>
    </>
  );
}
